import React from 'react';
import { Button, Tooltip } from 'antd';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';

const ServiceImageSection = ({ service, isFavorite, onToggleFavorite }) => {
  return (
    <div className="card">
      <div className="body">
        <div id="demo2" className="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            <Tooltip title={isFavorite ? "Unfavorite Service" : "Favorite Service"}>
              <Button 
                style={{ zIndex: 1000 }}
                type="text" 
                shape="circle" 
                icon={isFavorite ? <HeartFilled style={{ color: 'red' }} /> : <HeartOutlined />} 
                onClick={onToggleFavorite}
              />
            </Tooltip>
            <div className="carousel-item active">
              <img
                src={service.image}
                className="img-fluid"
                alt=""
                style={{ width: '100%', height: '400px', objectFit: 'cover' }}
              />                 
              <div className="carousel-caption">
                {/* <h3>voluptatem  </h3>
                <p>consectetur adipiscing elit!</p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceImageSection; 